var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.$store.state.setLoading,"can-cancel":false,"is-full-page":true}}),_c('v-snackbar',{attrs:{"value":_vm.$store.state.alert.show,"top":"","right":"","timeout":-1,"content-class":_vm.$store.state.alert.type}},[_vm._v(" "+_vm._s(_vm.$store.state.alert.message)+" ")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }